<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "StoreInformation",
  components: {NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let unit_id = useRoute().params.unit_id

    let units = []

    let information_unit = ref(null)

    function load_information() {

      loading.value = true

      FreeWorld.Heisenberg({action: 'unit'}, 'all_data', true).then((result) => {

        loading.value = false
        units = result.data
        change_unit()

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_information)
      })

    }

    load_information()

    function change_unit() {

      units.forEach((item) => {
        if (unit_id == item.id) {
          information_unit.value = item
        }
      })

    }


    return {

      loading,
      information_unit,

    }
  }


}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p class="m-0">
        اطلاعات فروشگاه
      </p>

      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>

    <div v-if="information_unit != null" class="animate__animated animate__fadeIn p-body my-3">

      <div class="bg-white rounded-4 p-body py-3 mb-3">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <p class="font-4 m-0 mx-2 font-bold">
            ساعات کاری
          </p>

          <img style="width: 20px" src="../assets/img/clock.svg">
        </div>
        <div class="d-flex justify-content-evenly">
          <div class="d-flex flex-column align-items-center">
            <p class="m-0 font-4 text-end mb-3 font-bold">
              عصر تا شب
            </p>
            <p class="m-0 font-4 text-end d-flex">
              <span>{{ information_unit.evening_from_hour }}</span>
              &nbsp;
              تا
              &nbsp;
              <span>{{ information_unit.evening_to_hour }}</span>
            </p>
          </div>
          <div class="d-flex flex-column align-items-center">
            <p class="m-0 font-4 text-end mb-3 font-bold">
              صبح تا ظهر
            </p>
            <p class="m-0 font-4 text-end d-flex">
              <span>{{ information_unit.morning_from_hour }}</span>
              &nbsp;
              تا
              &nbsp;
              <span>{{ information_unit.morning_to_hour }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">اطلاعات فروشگاه
    </div>

    <div v-if="information_unit != null"
         class="animate__animated animate__fadeIn w-75 ma-auto p-body bg-white p-3 rounded-4">

      <div class="shadow-costom rounded-4 p-body py-3 mb-3">
        <div class="d-flex align-items-center mb-3">
          <img style="width: 20px" src="../assets/img/clock.svg">

          <p class="font-3 m-0 mx-2 font-bold">
            ساعات کاری
          </p>
        </div>
        <div class="d-flex justify-content-evenly">
          <div class="d-flex flex-column align-items-center">
            <p class="m-0 font-3 text-end mb-3 font-bold">
              صبح تا ظهر
            </p>
            <p class="m-0 font-3 text-end d-flex">
              <span>{{ information_unit.morning_from_hour }}</span>
              &nbsp;
              تا
              &nbsp;
              <span>{{ information_unit.morning_to_hour }}</span>
            </p>
          </div>

          <div class="d-flex flex-column align-items-center">
            <p class="m-0 font-3 text-end mb-3 font-bold">
              عصر تا شب
            </p>
            <p class="m-0 font-3 text-end d-flex">
              <span>{{ information_unit.evening_from_hour }}</span>
              &nbsp;
              تا
              &nbsp;
              <span>{{ information_unit.evening_to_hour }}</span>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<style scoped>


.stars {
  width: 20px;
}

.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}

</style>